import { Briefcase, Coffee, ArrowUpRight, Sparkles } from "lucide-react";
import { CTA } from "@/lib/config";

export default function InlineCTABanner() {
  return (
    <section
      data-testid="inline-cta-banner"
      className="relative border-t border-b border-zinc-200 dark:border-zinc-800 bg-yellow-500 text-black overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none opacity-30">
        <div className="absolute -top-16 -left-16 w-72 h-72 rounded-full bg-black/10 blur-2xl" />
        <div className="absolute -bottom-24 -right-16 w-96 h-96 rounded-full bg-black/10 blur-2xl" />
      </div>

      <div className="relative mx-auto max-w-7xl px-6 py-14 md:py-20">
        <div className="grid grid-cols-12 gap-8 items-center">
          <div className="col-span-12 lg:col-span-7">
            <p className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest bg-black text-yellow-500 px-3 py-1.5">
              <Sparkles className="w-3 h-3" />
              // Got impressed?
            </p>
            <h2 className="mt-6 font-display font-extrabold text-4xl md:text-6xl leading-[0.95] tracking-tight text-black">
              Hire us to <br />
              <span className="italic">run your ads.</span>
            </h2>
            <p className="mt-5 text-black/80 text-base md:text-lg max-w-xl leading-relaxed">
              We&apos;re a performance-marketing team running high-ROAS Meta,
              Google, and YouTube campaigns for DTC brands, SaaS, and creators.
              You saw what we built for free — imagine what we&apos;ll build for
              your bottom line.
            </p>
            <ul className="mt-5 grid grid-cols-2 gap-2 text-sm text-black/80 max-w-xl">
              <li className="flex items-center gap-2"><span className="text-black">✓</span> Full-funnel Meta ads</li>
              <li className="flex items-center gap-2"><span className="text-black">✓</span> Creative + copy testing</li>
              <li className="flex items-center gap-2"><span className="text-black">✓</span> Weekly reporting</li>
              <li className="flex items-center gap-2"><span className="text-black">✓</span> ROAS-first, no vanity metrics</li>
            </ul>
          </div>

          <div className="col-span-12 lg:col-span-5 flex flex-col gap-4">
            <a
              href={CTA.hireUs}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="banner-hire-us-btn"
              className="group flex items-center justify-between gap-4 bg-black hover:bg-zinc-900 text-yellow-500 border-2 border-black px-6 h-16 md:h-20 font-bold text-base md:text-lg transition-all hover:-translate-y-1"
            >
              <span className="flex items-center gap-3">
                <Briefcase className="w-6 h-6" strokeWidth={2.5} />
                <span className="text-left leading-tight">
                  Hire us to run your ads
                  <span className="block text-xs font-mono uppercase tracking-widest text-yellow-500/70">
                    Book a free 20-min strategy call
                  </span>
                </span>
              </span>
              <ArrowUpRight className="w-6 h-6 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </a>

            <a
              href={CTA.buyCoffee}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="banner-buy-coffee-btn"
              className="group flex items-center justify-between gap-4 bg-transparent hover:bg-black/10 border-2 border-black text-black px-6 h-16 md:h-20 font-bold text-base md:text-lg transition-all hover:-translate-y-1"
            >
              <span className="flex items-center gap-3">
                <Coffee className="w-6 h-6" strokeWidth={2.5} />
                <span className="text-left leading-tight">
                  Buy us a coffee
                  <span className="block text-xs font-mono uppercase tracking-widest text-black/70">
                    loved this free tool? help us build it better
                  </span>
                </span>
              </span>
              <ArrowUpRight className="w-6 h-6 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
